export const SORTS = {
  bestTco: "bestTco",
  popular: "popular"
};
